// @flow
import * as React from "react"
import moment from "moment"
import {containers} from "@swarm2/core"
import "moment-duration-format"
import _ from "lodash"

// https://github.com/swarmsim/swarm/blob/master/app/scripts/filters/moment.coffee

const formats = {
  default_(duration) {
    // copied from swarmsim 1
    if (duration.asYears() >= 1) return "y [years] M [months]"
    if (duration.asMonths() >= 1) return "M [months] d [days]"
    if (duration.asDays() >= 1) return "d [days] h [hours]"
    if (duration.asMinutes() >= 1) return "h:mm:ss"
    else return {template: "00:ss", trim: false}
  },
  countdown(duration) {
    if (duration.asYears() >= 1) return "y:MM:dd:hh:mm:ss"
    if (duration.asMonths() >= 1) return "M:dd:hh:mm:ss"
    if (duration.asDays() >= 1) return "d:hh:mm:ss"
    if (duration.asMinutes() >= 1) return "h:mm:ss"
    else return {template: "00:ss", trim: false}
  },
}
// TODO millis type
export function duration(millis: number, noSuffix?: boolean) {
  return _duration(millis, {noSuffix})
}
function _duration(millis, props: {noSuffix?: boolean, format?: string} = {}) {
  const {noSuffix = false, format = "default_"} = props
  const diff = moment.duration(Math.abs(millis))
  const tmpl = formats[format](diff)
  const suffix = millis < 0 && !noSuffix ? " ago" : ""
  return (diff: any).format(tmpl) + suffix
}
export function fromNow(since: number, now: number, noSuffix?: boolean) {
  return duration(since - now, noSuffix)
}
export const FromNow = containers.common.FromNow(props => {
  if (props.isError) {
    // no LoadingSpinner, <div>-in-<p> warnings
    return (
      <span
        title={JSON.stringify(
          _.pick(props, [
            "isError",
            "isPending",
            "pendingKeys",
            "isEmpty",
            "emptyKeys",
          ]),
        )}
      >
        ...
      </span>
    )
  }
  const {since, now, noSuffix} = props
  return <span>{fromNow(since, now, noSuffix)}</span>
})

export function Duration(props: *) {
  const {millis, noSuffix, format} = props
  return <span>{_duration(millis, {noSuffix, format})}</span>
}

// ripped from swarm1/util.coffee
// http://stackoverflow.com/questions/13262621
//export function utcdoy(ms) {
//  //const t = moment.utc(ms)
//  const t = moment.duration(ms)
//  const days = parseInt(t.format('DDD'))-1
//  const daystr = days > 0 ? days+'d ' : ''
//  console.log('!', daystr + t.format('H\\h mm:ss.SSS'))
//  return daystr + t.format('H\\h mm:ss.SSS')
//}



// WEBPACK FOOTER //
// ./src/common/DateTime.js